export default "__VITE_ASSET__CdKSZxFt__"